import z from "zod";
export const storedErrorSchema = z.object({
    errorMessage: z.string().nullable(),
    errorCode: z.string().nullable().optional(),
    errorParams: z.record(z.string(), z.unknown()).nullable().optional(),
});
export const storedErrorReportSchema = z.object({
    errorMessage: z.string(),
    errorCode: z.string().optional(),
    errorParams: z.record(z.string(), z.unknown()).optional(),
});
//# sourceMappingURL=stored-error.schema.js.map